export enum CalendarViewTypeEnum {
    Weekly = "Weekly",
    Daily = "Daily",
    Map = "Map",
    SummaryView = "Summary View"
}
